'use client'

import Script from 'next/script'

import { AGTM_SCRIPT_ID, AGTM_SCRIPT_SRC } from '@/lib/tracking/config'

import { COOKIE_CONSENT_CATEGORY, COOKIE_CONSENT_SERVICE } from './constants'
import { useCookieConsent } from './consentStore'

export function TrackingScript() {
  const analyticsAccepted = useCookieConsent({
    category: COOKIE_CONSENT_CATEGORY.analytics,
    service: COOKIE_CONSENT_SERVICE.googleAnalytics,
  })
  const adsAccepted = useCookieConsent({
    category: COOKIE_CONSENT_CATEGORY.marketing,
    service: COOKIE_CONSENT_SERVICE.googleAds,
  })
  const metaAccepted = useCookieConsent({
    category: COOKIE_CONSENT_CATEGORY.marketing,
    service: COOKIE_CONSENT_SERVICE.metaPixel,
  })

  if (!analyticsAccepted && !adsAccepted && !metaAccepted) {
    return null
  }

  return <Script id={AGTM_SCRIPT_ID} src={AGTM_SCRIPT_SRC} strategy="afterInteractive" />
}
